export const LOAD_REASONS = 'LOAD_REASONS'
export const LOAD_REASON_TYPES = 'LOAD_REASON_TYPES'
export const ADD_REASON = 'ADD_REASON'

